var e={SIMPLE:"simple",COMPLEX:"complex"};export{e as TooltipType};
//# sourceMappingURL=types.js.map
